import { GetStoryInputApiModel } from '@modules/company-admin/store/models/api-models/input/get-story-input.api-model';
import { Action } from '@ngrx/store';



export enum ActionTypes {
    POST_REMINDER = '[Reminder] Post Reminder',
    POST_REMINDER_SUCCESS = '[Reminder] Post Reminder Success',
    POST_REMINDER_FAILURE = '[Reminder] Post Reminder Failure',

    GET_REMINDER = '[Reminder] Get Reminder',
    GET_REMINDER_SUCCESS = '[Reminder] Get Reminder Success',
    GET_REMINDER_FAILURE = '[Reminder] Get Reminder Failure'
}

export class PostReminder implements Action {
    readonly type = ActionTypes.POST_REMINDER;

    constructor(public payload: any) { }
}

export class PostReminderSuccess implements Action {
    readonly type = ActionTypes.POST_REMINDER_SUCCESS;

    constructor(public response: any) { }
}

export class PostReminderFailure implements Action {
    readonly type = ActionTypes.POST_REMINDER_FAILURE;

    constructor(public error: any) { }
}

export class GetReminder implements Action {
    readonly type = ActionTypes.GET_REMINDER;

    constructor(public id: number, public query:GetStoryInputApiModel) { }
}

export class GetReminderSuccess implements Action {
    readonly type = ActionTypes.GET_REMINDER_SUCCESS;

    constructor(public response: any) { }
}

export class GetReminderFailure implements Action {
    readonly type = ActionTypes.GET_REMINDER_FAILURE;

    constructor(public error: any) { }
}

export type Actions =
    | PostReminder
    | PostReminderSuccess
    | PostReminderFailure
    | GetReminder
    | GetReminderSuccess
    | GetReminderFailure;